// eslint-disable-next-line import/prefer-default-export
export const IT = '1978BE88986';
